import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/Auth';

/**
 * LoginRoute – React Router DOM v6
 *
 * Usado para páginas públicas (ex: /login)
 * Se o usuário JÁ estiver autenticado, redireciona
 * para a rota de origem ou para '/'
 *
 * Uso no routes:
 * {
 *   element: <LoginRoute />,
 *   children: [{ path: '/login', element: <Login /> }]
 * }
 */
const LoginRoute: React.FC = () => {
    const { isAuth } = useAuth();
    const location = useLocation();

    const redirectableLocation = (location.state as any)?.from;

    if (isAuth) {
        return <Navigate to={redirectableLocation || '/'} replace />;
    }

    return <Outlet />;
};

export default LoginRoute;
